import { render, staticRenderFns } from "./ObiAlert.vue?vue&type=template&id=ca89a57e&scoped=true&"
import script from "./ObiAlert.vue?vue&type=script&lang=js&"
export * from "./ObiAlert.vue?vue&type=script&lang=js&"
import style0 from "./ObiAlert.vue?vue&type=style&index=0&id=ca89a57e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca89a57e",
  null
  
)

export default component.exports